import React from 'react'
import PropTypes from 'prop-types'
import BackButton from '../misc/BackButton'
import paperPlaneLight from '../../assets/illustrations/paperplane-light.svg'
import paperPlaneDark from '../../assets/illustrations/paperplane-dark.svg'
import {useI18nContext} from "../i18n/I18nContext";
import {getI18nTextWithContext} from "wipi-common/src/lib/i18n";

export default function StartBasicMailConfirmed({isMobileDevice, backToBranchUrl, continueToBranchBtn}) {
    const context = useI18nContext();
    const mailSentText = getI18nTextWithContext(context, 'startBasic.mailSent');

    return <>
        <div className="row">
            <div className="col-lg-6 offset-lg-3 col-md-8 offset-md-2 col-sm-12">
                <div className="text-center mt-3">
                    <img id="paperplane-light" src={paperPlaneLight} alt="Papierflieger" className="img-fluid" width="140"
                         data-test-id="08ab785a-ecf3"/>
                    <img id="paperplane-dark" src={paperPlaneDark} alt="Papierflieger" className="img-fluid" width="140"
                         data-test-id="08ab785a-ecf3"/>
                </div>
                <p className="text-center mt-5 mb-5" data-test-id="de03a01f-b5b1">
                    <strong>{mailSentText}</strong>
                </p>
            </div>
        </div>
        <hr />
        <section className="btn-section">
            <BackButton isMobileDevice={isMobileDevice} to="/basic" iconOnly={true}/>
            {backToBranchUrl &&
            <button className="pi-btn pi-btn--primary" onClick={() => {
                window.location.replace(backToBranchUrl)
            }}>
                {continueToBranchBtn}
            </button>
            }
        </section>
    </>
}

StartBasicMailConfirmed.propTypes = {
    isMobileDevice: PropTypes.bool.isRequired,
    backToBranchUrl: PropTypes.string,
    continueToBranchBtn: PropTypes.string
}
